import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import { Card } from "./Card";
import { type CardDataProps, cardDataSchema } from "./Card.schema";
import { CARD_TAG_NAME } from "./constants";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    [CARD_TAG_NAME]: { props: CardDataProps; handle: undefined };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-card": HTMLElement;
  }
}

function RWCCard(props: CardDataProps): JSX.Element {
  return (
    <Card {...props}>
      <slot />
    </Card>
  );
}

componentManager.register(
  rwc(CARD_TAG_NAME, {
    component: RWCCard,
    dataSchema: cardDataSchema,
    usesSlots: true,
  }),
);
